export default "__VITE_ASSET__CJm9l7Do__"